module.exports = __webpack_public_path__ + "img/login-right.c29f0f78.svg";